/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const useRouter = () => {
  if (typeof window === 'undefined') {
    return {
      push: () => {},
      replace: () => {},
      back: () => {},
      setParams: () => {},
    };
  }

  const { useRouter } = require('next/navigation');
  return useRouter();
};

export const useLocalSearchParams = () => {
  if (typeof window === 'undefined') return {};

  const { useSearchParams } = require('next/navigation');
  const params = useSearchParams();
  return Object.fromEntries(params.entries());
};

export const useGlobalSearchParams = useLocalSearchParams;

export const Link = ({ href, children, ...props }) => {
  const NextLink = require('next/link').default;
  return (
    <NextLink href={href} {...props}>
      {children}
    </NextLink>
  );
};

export const Stack = ({ children }) => <>{children}</>;
export const Tabs = ({ children }) => <>{children}</>;

export default {};
